// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KFFa","title":"styles_title__2FwKE"};